import React, { useContext, useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useMutation, useQueryClient } from "react-query"
import { mutationRequest } from "../../util/request"
import { UserContext } from "../HomeApp"
import { useReactions } from "../../hooks/useReactions"
import { isEventOver } from "../../util/ticketUtils"
import { openAuthDialog } from "../Authentication"

const BandNadaTicketRSVPText = ({ postId, eventEndDate }) => {
  const { user } = useContext(UserContext)
  const dispatch = useDispatch()
  const [userInterestedState, setUserInterestedState] = useState("")
  const queryClient = useQueryClient()

  // Check if user has already RSVP'd
  const { data: rsvpData, isLoading } = useReactions(
    "Post",
    postId,
    "rsvps",
    true,
  )

  useEffect(() => {
    if (!isLoading && rsvpData?.current_user_setting?.reaction_type) {
      setUserInterestedState(rsvpData.current_user_setting.reaction_type)
    }
  }, [isLoading, rsvpData])

  const mutation = useMutation(mutationRequest)

  const handleRSVP = async (e) => {
    e.preventDefault()

    if (!user) {
      dispatch(
        openAuthDialog({
          explanation: "You must first sign up or log in to RSVP to an event",
        }),
      )
      return
    }

    await mutation.mutate({
      options: { method: "POST" },
      path: `/api/v1/reactions`,
      data: {
        reaction: {
          content_type: "Post",
          content_id: postId,
          post_id: postId,
          reaction_type: "interested",
        },
        filter: "rsvps",
      },
    })
  }

  useEffect(() => {
    if (mutation.isSuccess) {
      setUserInterestedState("interested")
      queryClient.invalidateQueries("user-posts")
    }
  }, [mutation.isSuccess])

  // Don't show if event has ended or user has already RSVP'd
  if (isEventOver(eventEndDate) || userInterestedState === "interested") {
    return null
  }

  return (
    <>
      <div className="text-sm text-gray-600 mt-4">
        Undecided on purchasing a ticket but still interested? Click{" "}
        <a
          href="#"
          onClick={handleRSVP}
          className="text-blue-600 hover:text-blue-800 underline"
        >
          here
        </a>{" "}
        to RSVP and add the show to your bandNada calendar.
      </div>

    </>
  )
}

export default BandNadaTicketRSVPText
